// 2021-06-20 C0125 Add this for config base url for axio

let baseURL = 'https://api.pgebet.com/' // 核心业务请求API
let service2URL = 'https://api.pgebet.com/' // 非核心业务请求API
let version = '4.3.134'
let apkVersion = '1.5.2'
let agentWebsite

baseURL = 'https://api.pgebet.com/'
service2URL = baseURL
agentWebsite = baseURL

let config = {
  baseURL: baseURL,
  version: version,
  apkVersion: apkVersion,
  service2URL: service2URL,
  logPath: ['Landing1', 'Landing2', 'Landing3', 'Landing4', 'Home'],
  agentWebsite
}
export default config



//////////////////
// WEBPACK FOOTER
// ./static/config/config.js
// module id = null
// module chunks = 